export default {
  REDIRECT_TO_STORE: '@WS_EDITOR/ONLINESTORE/REDIRECT_TO_STORE',
};
